// =============================================================================
// Gamora — Badge global header OmniHub
// =============================================================================
// Lit /api/governance/gamora/latest et affiche 🔴 si totals.critique > 0.
// Au clic → navigue vers Gouvernance > Gamora.
// =============================================================================

import { useState, useEffect } from "react";
import { ShieldAlert } from "lucide-react";
import { getTenantHeaders } from "../../lib/utils";

const API = process.env.REACT_APP_BACKEND_URL || "";

export default function GamoraGlobalBadge({ onClick }) {
  const [n, setN] = useState(0);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const res = await fetch(`${API}/api/governance/gamora/latest`, {
          headers: getTenantHeaders(), credentials: "include",
        });
        if (res.ok && mounted) {
          const data = await res.json();
          setN(data?.report?.totals?.critique || 0);
        }
      } catch { /* silent */ }
    };
    load();
    const int = setInterval(load, 5 * 60 * 1000);
    return () => { mounted = false; clearInterval(int); };
  }, []);

  if (n === 0) return null;

  return (
    <button
      onClick={onClick}
      className="inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all hover:scale-105"
      style={{ background: "rgba(220,38,38,0.15)", color: "#fca5a5", border: "1px solid rgba(220,38,38,0.4)" }}
      title={`Gamora — ${n} anomalie(s) critique(s) non résolue(s)`}
      data-testid="gamora-global-badge"
    >
      <ShieldAlert className="w-4 h-4 animate-pulse" />
      <span>Gamora · {n}</span>
    </button>
  );
}
